import AUTH_STATE from './'
import AuthActions from './actions'

export function reducer(state = AUTH_STATE, action) {

  switch (action.type) {
    case AuthActions.accessTokenSaved().type:
      return state.merge({
        access_token: action.payload.token,
      })
    case AuthActions.setUser().type:
      return state.merge({ user: action.payload.user })

    case AuthActions.noAuth().type:
      return state.merge({
        user: null,
        access_token: null,
        loading: false,
      })
    case AuthActions.verifyAuth().type:
      return state.merge({
        loading: true,
       })

    case AuthActions.restoredAuth().type:
      return state.merge({
        loading: false,
      })
    default:
      return state
  }
}
